import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import ReferralList from "./Residential/Optional/Referral/ReferralList";

import {
    fetchReferralForms,
    deleteReferralForm,
} from "../store/slices/referralFormsSlice";

const Referrals = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { referralForms, isLoading } = useSelector((state) => state.referralForms);

    useEffect(() => {
        dispatch(fetchReferralForms());
    }, [dispatch]);

    const handleAdd = () => navigate("/residential/optional/referral-form/add");

    const handleEdit = (id) =>
        navigate(`/residential/optional/referral-form/edit/${id}`);

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Confirm Delete",
            text: "Do you want to delete this Referral?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            dispatch(deleteReferralForm(id))
                .unwrap()
                .then(() => Swal.fire("Deleted!", "Referral removed.", "success"))
                .catch(() => Swal.fire("Error!", "Failed to delete record.", "error"));
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <ReferralList
                            records={referralForms}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default Referrals;
